import { apiService } from './apiService';

const API_URL = (process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api') + '/token/' ;

export const authService = {
  login: async (email: string, password: string) => {
    const data = await apiService.post(API_URL, {
      username: email,
      password,
    });
    return {
      access: data.access,
      refresh: data.refresh,
    };
  },
}; 